// extracted by mini-css-extract-plugin
export default {"container":"df_d","partText":"df_lz","logoText":"df_lB","awardsContainer":"df_lC","awardImage":"df_lD"};